import Link from "next/link";
import Image from "next/image";
import { ArrowRight, Search } from "lucide-react";
import LoadingSpinner from "@/components/LoadingSpinner";
import BannerSkeleton from "./_bannerSkeleton";

const NavLoadingBlog = () => (
    <nav className="hidden w-full lg:flex items-center justify-center gap-6 border-b border-jmt-neutral-200">
        {[...Array(5)].map((_, index) => (
            <div key={index} className="flex items-center py-4">
                <div className="h-5.5 w-[90px] xl:w-[110px] rounded-md bg-jmt-neutral-100" />
            </div>
        ))}
    </nav>
);

export default function HeaderBlogSSR({ pathname = "", banner_count = 0 }) {
    const isBlogHome = pathname.replace(/\/+$/, "") === "/blogs";

    return (
        <header dir="rtl" className="relative w-full">
            <div className="fixed top-0 right-0 left-0 z-40 bg-jmt-white">

                {banner_count > 0 && <BannerSkeleton count={banner_count} />}

                {/* Mobile */}
                <div className="block lg:hidden">
                    <section className="w-full bg-jmt-white shadow-buttom-light">
                        <div className="container">
                            {/* هم‌شکل هدر موبایل کلاینت: برگشت (غیر از خانه‌ی مجله) و لوگو وسط */}
                            <div className="w-full py-3 grid grid-cols-[40px_1fr_40px] items-center gap-4">

                                {isBlogHome ? <span /> : (
                                    <div className="w-10 h-10 flex items-center justify-center text-jmt-neutral-900">
                                        <ArrowRight size={24} />
                                    </div>
                                )}

                                <Link href="/blogs/" className="flex justify-self-center">
                                    <div className="w-[130px] h-6">
                                        <Image
                                            src="/images/logo/blog-logo.png"
                                            unoptimized
                                            alt="لوگو ژومنت"
                                            className="object-contain w-full h-full"
                                            width={130}
                                            height={24}
                                            priority
                                        />
                                    </div>
                                </Link>

                                {/* ستون خالی برای وسط‌ماندن لوگو */}
                                <span />

                            </div>
                        </div>
                    </section>
                </div>

                {/* Desktop */}
                <div className="hidden lg:block">
                    <section className="w-full">

                        {/* row 1 */}
                        <div className="w-full mx-auto py-4 border-b border-jmt-neutral-200">
                            <div className="container">
                                <div className="w-full flex items-center justify-between">
                                    <Link
                                        href="/home"
                                        className="text-sm font-bold text-jmt-primary-800 hover:text-jmt-primary-900"
                                    >
                                        رفتن به فروشگاه ژومنت
                                    </Link>

                                    <Link href="/" className="flex">
                                        <div className="w-[194px] h-10">
                                            <Image
                                                src="/images/logo/blog-logo.png"
                                                unoptimized
                                                alt="لوگو ژومنت"
                                                className="object-contain w-full h-full"
                                                width={194}
                                                height={40}
                                                priority
                                            />
                                        </div>
                                    </Link>

                                    <div className="flex items-center justify-end gap-6">
                                        <div className="w-10 h-10 flex items-center justify-center">
                                            <Search size={24} className="text-jmt-neutral-800" />
                                        </div>
                                        <div className="flex items-center justify-center text-jmt-neutral-800">
                                            <LoadingSpinner size={22} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* row 2 */}
                        <NavLoadingBlog />
                    </section>
                </div>
            </div>
        </header>
    );
}
